import { render, staticRenderFns } from "./showrealtime.vue?vue&type=template&id=359f0d6e&scoped=true&"
import script from "./showrealtime.vue?vue&type=script&lang=js&"
export * from "./showrealtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f0d6e",
  null
  
)

export default component.exports